<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import { mapMutations } from "vuex";
import { getQuery } from "@/utils/util";
export default {
  name: "App",
  components: {},
  created() {
    if (getQuery("auth")) {
      this.SET_USERINFO(JSON.parse(getQuery("userInfo")));
      this.SET_AUTHORIZATION(getQuery("auth"));
    }
  },
  computed: {},
  methods: {
    ...mapMutations([
      "SET_AUTHORIZATION",
      "SET_USERINFO",
    ])
  }
};
</script>

<style lang="scss">
body {
  margin: 0;
}
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100vh;
}
/*全局滚动条样式*/
::-webkit-scrollbar {
  width: 5px;
  height: 14px;
}
::-webkit-scrollbar-thumb {
  background-color: #b6b6b6;
}
.el-menu--popup,
.el-menu-item {
  background: #353947 !important;
}
.el-menu--popup {
  display: flex;
  max-width: 460px;
  flex-wrap: wrap;
  padding: 16px 8px 0 !important;
  box-sizing: border-box;
  justify-content: space-between;
  border-radius: 20px !important;
  .down-drop-menu {
    width: 460px !important;
    display: flex;
    .down-left {
      width: 66%;
      display: flex;
      flex-wrap: wrap;
    }
    .line {
      width: 1px;
      background: #20232e;
      margin-bottom: 16px;
    }
    .line1 {
      width: 1px;
      background: #565963;
      margin-bottom: 16px;
    }
  }
  .el-menu-item {
    width: 130px !important;
    height: 36px !important;
    line-height: 36px !important;
    background: #4a5064 !important;
    border-radius: 18px !important;
    text-align: center;
    margin: 0 8px;
    margin-bottom: 16px;
    &.is-active {
      background: #ea6a44 !important;
    }
  }
}
.create-isLoading .el-loading-spinner .el-loading-text,
.create-isLoading .el-loading-spinner i {
  color: #ea6a44;
}
</style>
